import { type KeyboardEvent, type MouseEvent, TouchEvent } from 'react';

/**
 * Checks whether an event comes from the HTML element that has the event listener.
 * In case it comes from a child element, returns false.
 * @param event -
 */
export const isOwnEvent = (event: MouseEvent | TouchEvent | KeyboardEvent) =>
  event.currentTarget === event.target;
